import { z } from 'zod';
import { dateBeforeOnOCSCheck, getDateTimeInputValues } from '../config';
import { FirstLungFlushForm, SecondLungFlushForm } from '../types';
import { CaseFacility } from '@/api/apis/case';
import { createDateTimeFields } from '@/utils/helpers';

const firstLungDateTimeSchema = z.object(
  createDateTimeFields({
    date: 'firstLungDate',
    time: 'firstLungTime',
    timezone: 'firstLungTimeZone',
  }) as {
    firstLungDate: z.ZodString;
    firstLungTime: z.ZodString;
    firstLungTimeZone: z.ZodString;
  },
);

const secondLungDateTimeSchema = z.object(
  createDateTimeFields({
    date: 'secondLungDate',
    time: 'secondLungTime',
    timezone: 'secondLungTimeZone',
  }) as {
    secondLungDate: z.ZodString;
    secondLungTime: z.ZodString;
    secondLungTimeZone: z.ZodString;
  },
);

export const sequentialFlushSchema = firstLungDateTimeSchema
  .extend(secondLungDateTimeSchema.shape)
  .extend({
    onOcsTimestamp: z.string(),
  })
  .refine(dateBeforeOnOCSCheck<FirstLungFlushForm>('firstLungDate', 'firstLungTime', 'firstLungTimeZone'), {
    message: "Off OCS time can't be before On OCS time",
    path: ['firstLungDate'],
  })
  .refine(dateBeforeOnOCSCheck<SecondLungFlushForm>('secondLungDate', 'secondLungTime', 'secondLungTimeZone'), {
    message: "Off OCS time can't be before On OCS time",
    path: ['secondLungDate'],
  });

export const getSequentialFlushDefaultValues = (txCenter?: CaseFacility, ocsStartTimestamp?: string) => {
  const { date, time, timeZone } = getDateTimeInputValues(txCenter);

  return {
    firstLungDate: date,
    firstLungTime: time,
    firstLungTimeZone: timeZone,
    secondLungDate: date,
    secondLungTime: time,
    secondLungTimeZone: timeZone,
    onOcsTimestamp: ocsStartTimestamp,
  };
};
